import React from "react";
import { noop } from "lodash";
import { TagSearchSortTypes } from "@features/library/types";
import { SearchFilterInput } from "@thenounproject/lingo-core";

type TagLibraryContextType = {
  query: string;
  setQuery: (value: string) => void;
  sort: TagSearchSortTypes;
  setSortBy: (sort: TagSearchSortTypes) => void;
  filters: SearchFilterInput[];
};

export const initialState: TagLibraryContextType = {
  filters: [],
  query: "",
  setQuery: noop,
  sort: TagSearchSortTypes.alpha,
  setSortBy: noop,
};

export const TagLibraryContext = React.createContext<TagLibraryContextType>(initialState);

TagLibraryContext.displayName = "TagLibraryContext";
